(()=>{
const root=document.querySelector('.fq[data-page="faq"]');
if(!root)return;
const $=selector=>root.querySelector(selector);
const rawLang=document.documentElement.lang||'en';
let dict={};
try{dict=JSON.parse($('#fq-i18n').textContent)||{};}catch(e){dict={};}
const t=(key,vars)=>{let text=dict[key]||key;if(vars)for(const name in vars)text=text.split('{'+name+'}').join(vars[name]);return text;};

/* Topic tabs: roving tabindex, arrow keys, Home and End, shareable #topic */
const tabsEl=$('#fq-tabs');
const tabs=Array.from(root.querySelectorAll('[role="tab"]'));
const filterWrap=$('.fq-filter');
function updateEnd(){
 if(!tabsEl||!filterWrap)return;
 filterWrap.toggleAttribute('data-end',tabsEl.scrollLeft+tabsEl.clientWidth>=tabsEl.scrollWidth-4);
}
function choose(tab,focus,remember){
 tabs.forEach(x=>{
  const on=x===tab;
  x.setAttribute('aria-selected',String(on));x.tabIndex=on?0:-1;
  const panel=document.getElementById(x.getAttribute('aria-controls'));
  if(panel)panel.hidden=!on;
 });
 if(tabsEl.scrollWidth>tabsEl.clientWidth)tabsEl.scrollLeft=Math.max(0,tab.offsetLeft-(tabsEl.clientWidth-tab.offsetWidth)/2);
 updateEnd();
 if(focus)tab.focus();
 if(remember&&window.history&&history.replaceState)history.replaceState(null,'','#'+tab.dataset.topic);
}
tabs.forEach((tab,i)=>{
 tab.addEventListener('click',()=>choose(tab,false,true));
 tab.addEventListener('keydown',event=>{
  const next={ArrowRight:(i+1)%tabs.length,ArrowLeft:(i+tabs.length-1)%tabs.length,Home:0,End:tabs.length-1}[event.key];
  if(next!==undefined){event.preventDefault();choose(tabs[next],true,true);}
 });
});
if(tabsEl){tabsEl.addEventListener('scroll',updateEnd,{passive:true});window.addEventListener('resize',updateEnd);}
function fromHash(scroll){
 const id=(location.hash||'').replace('#','');
 const tab=tabs.find(x=>x.dataset.topic===id);
 if(!tab)return false;
 choose(tab,false,false);
 if(scroll){const top=tabsEl.getBoundingClientRect().top+scrollY-90;window.scrollTo(0,Math.max(0,top));}
 return true;
}
if(!fromHash(true))updateEnd();
window.addEventListener('hashchange',()=>fromHash(false));

/* Mobile sticky action */
const sticky=$('.fq-mobile-action');const visible=new Map();
if(sticky&&'IntersectionObserver' in window){
 const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>visible.set(entry.target,entry.isIntersecting));sticky.hidden=[...visible.values()].some(Boolean);},{threshold:.05});
 [$('.fq-hero'),$('#fq-setup'),$('#fq-demo'),$('.fq-close')].forEach(section=>{if(section)observer.observe(section);});
}

/* Live price, saving, rating and Premium Care value from the store's own product data */
const studioId=String(root.dataset.studioId||'');
if(studioId){
const abort=new AbortController();const timer=setTimeout(()=>abort.abort(),8000);
/* Product JSON is fetched from the product URLs Liquid emits (market and locale prefixed, translated handles included),
   so the price is always the visitor's market price. There is no fallback to a root path. */
function fetchProduct(path){
 return fetch(path,{signal:abort.signal}).then(response=>{if(!response.ok)throw new Error('Unavailable');return response.json();});
}
const baseUrl=()=>{const a=$('#fq-price');return a?new URL(a.getAttribute('href').split('?')[0],location.origin).href:'';};
const gm3Url=baseUrl();
Promise.all([
 fetchProduct(root.dataset.productJs),
 (root.dataset.careJs&&root.dataset.careJs!=='.js'?fetchProduct(root.dataset.careJs).catch(()=>null):Promise.resolve(null))
]).then(([product,premiumCare])=>{
 const studioSku=root.dataset.studioSku||'GM3STUDIO';
 const usable=v=>v.available&&Number(v.price)>0;
 const variant=(product.variants||[]).find(v=>studioId&&String(v.id)===studioId&&usable(v))||(product.variants||[]).find(v=>v.sku===studioSku&&usable(v));
 if(!variant)return;
 const currency=product.currency||(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active);
 if(!currency)return;
 const vat=Number(root.dataset.vat)||0;
 const withVat=cents=>vat?Math.ceil(cents*(1000+vat)/100000)*100:cents;
 const money=amount=>new Intl.NumberFormat(rawLang,{style:'currency',currency,currencyDisplay:'narrowSymbol',minimumFractionDigits:0,maximumFractionDigits:0,useGrouping:'always'}).format(amount/100);
 const price=withVat(Number(variant.price)),compareAt=withVat(Number(variant.compare_at_price||0));
 const hasSaving=compareAt>price;
 const save=hasSaving?compareAt-price:0;
 const priceText=money(price);
 const productUrl=gm3Url+'?variant='+encodeURIComponent(variant.id);
 const priceEl=$('#fq-price');priceEl.textContent=priceText;priceEl.href=productUrl;
 const taxNote=$('#fq-price-note');if(taxNote)taxNote.textContent=t('tax');
 if(hasSaving){
  $('#fq-price-compare-value').textContent=money(compareAt);$('#fq-price-compare').hidden=false;
  const saveEl=$('#fq-price-save');saveEl.textContent=t('save_chip',{save:money(save)});saveEl.hidden=false;
 }
 const productLink=$('#fq-product-link');productLink.href=productUrl;productLink.innerHTML=(hasSaving?t('product_save',{price:priceText}):t('product_default'))+' <span aria-hidden="true">→</span>';
 const closeCta=$('#fq-close-cta');closeCta.textContent=hasSaving?t('close_save',{save:money(save)}):t('cta_default');closeCta.href=productUrl;
 if(variant.featured_image&&variant.featured_image.src){const productImg=$('#fq-product-image');if(productImg)productImg.src=variant.featured_image.src;}
 const careVariant=premiumCare&&Array.isArray(premiumCare.variants)?premiumCare.variants[0]:null;
 const careValue=careVariant&&Number(careVariant.price)>0?money(withVat(Number(careVariant.price))):null;
 const tick=$('#fq-tick-care-value');
 if(tick)tick.textContent=careValue?t('care_value',{value:careValue}):'';
}).catch(()=>{}).finally(()=>clearTimeout(timer));

}
})();
